import { Check, TriangleAlert } from "lucide-react";
import React from "react";
import { useFastCondoUserStore } from "./context";

export function WizardStepTrigger({
   step,
   onClick,
   label,
   icon,
   validationFields = [],
   ...props
}) {
   const {
      totalSteps,
      step: currentStep,
      errors,
      setStep
   } = useFastCondoUserStore();

   const hasErrors = !!Object.entries(errors)?.find(([field, value]) => validationFields.includes(field) && value.length > 0);

   return (
      <button
         className={`
            relative size-[44px] flex items-center justify-center rounded-full border-2 
            ${step < totalSteps ? 'mr-[105px]!' : ''} 
            ${currentStep > step ? 'bg-(--primaryColor) [&>svg]:text-white border-(--primaryColor)' : (currentStep === step ? 'bg-transparent [&>svg]:text-(--primaryColor) border-(--primaryColor)' : 'bg-(--borderColor) [&>svg]:text-(--textColor) border-(--borderColor)')}
            ${hasErrors ? 'bg-transparent! border-red-500! [&>svg]:text-red-500!' : ''}
         `}
         type="button"
         onClick={(e) => {
            onClick?.(e);
            setStep(step);
         }} {...props}
      >
         {currentStep > step ? (
            <Check size={22} />
         ) : (
            React.createElement(icon, { size: 22 })
         )}
         {step < totalSteps && (
            <>
               {currentStep === step + 1 ? (
                  <svg className={`absolute top-1/2 left-[calc(100%+2px)] -translate-y-1/2`} width="105" height="4">
                     <path
                        className="ants-rect"
                        d="M0,2 H105"
                     />
                  </svg>
               ) : (
                  <span className={`absolute top-1/2 left-[calc(100%+2px)] -translate-y-1/2 w-[105px] h-[3px] ${currentStep > step + 1 ? 'bg-(--primaryColor)' : 'bg-(--borderColor)'}`}></span>
               )}
            </>
         )}
         <span className="absolute top-[calc(100%+10px)] text-(--textColor) uppercase font-bold! text-[0.7rem]! tracking-[1px]! flex flex-row items-center gap-1">
            {hasErrors && (
               <TriangleAlert size={14} className="text-red-500!" />
            )}
            {label}
         </span>
      </button>
   );
}
